export default {
  'candidateReport.upload.success': '{count} File{count, plural, one {} other {s}} uploaded successfully',
  'candidateReport.upload.error': 'Error uploading files.\n{error}',
  'candidateReport.auth.expired': 'Your session has expired. Please reload the page or log in again.',
  'candidateReport.auth.title': 'Session Expired',
  'candidateReport.buttons.reload': 'Reload Page',
  'candidateReport.buttons.login': 'Log In Again',
  'candidateReport.buttons.upload': 'Upload',
  'candidateReport.buttons.download': 'Download ({count, plural, =0 {All} other {#}})',
  'candidateReport.buttons.delete': 'Delete ({count, plural, =0 {All} other {#}})',
  'candidateReport.buttons.trafficLight': 'Create Traffic Light Report ({count})',
  'candidateReport.buttons.help': 'Help',
  'candidateReport.empty.message': 'Please select a résumé or CV to upload for candidate report conversion.',
  'candidateReport.filter.noResults': 'No candidate reports match your filter criteria. Try adjusting your search.',
  'candidateReport.error.file.select': 'Please select a file first',
  'candidateReport.error.file.type': 'Please select a file with the following types: {types}',
  'candidateReport.error.failed.delete': 'Failed to delete file.',
  'candidateReport.error.no.files.delete': 'No files to delete',
  'candidateReport.success.delete':
    '{count, plural, =1 {1 Candidate Report deleted successfully} other {# Candidate Reports deleted successfully}}',
  'candidateReport.processed.date': 'Processed: {date}',
  'candidateReport.delete.success':
    '{count, plural, =1 {1 Candidate Report deleted successfully} other {# Candidate Reports deleted successfully}}',
  'candidateReport.filter.jobNumber.placeholder': 'Filter by Job Number',
  'candidateReport.info.title': '## Information',
  'candidateReport.delete.confirmTitle': 'Delete Candidate Reports?',
  'candidateReport.delete.confirmMessage':
    'Are you sure you want to delete {count} {count, plural, one {report} other {reports}}?',
  'candidateReport.info.description':
    'Please upload candidate original résumés via the \'upload résumé\' button at the top right. Once all candidate reports have been uploaded, you can then generate your Traffic Light Report.',
  'candidateReport.info.content': `
Please upload candidate original résumés via the 'upload résumé' button at the top right. Once all candidate reports have been uploaded, you can then generate your Traffic Light Report.

* By uploading multiple résumés at once, relevant fields (including role applied for, hiring organisation, and so on) will be copied across candidate reports so you do not have to re-type it.
* Single candidate reports will download as MS Word format files (.docx), while multiple candidate reports downloaded at once will be placed within a single .ZIP file.
* While the AI-generated content has been trained on SHK's language and tone, AI-generated content by nature is not 100% perfect.
* Consultants are required to critically proofread all output before sending any AI-generated collateral to clients.
`,
  'candidateReport.error.unauthorised': 'Unauthorised: Please log in again',
  'candidateReport.error.file.count': 'You can only upload up to {maxFiles} files at once',
  // Modal messages
  'modal.candidateReport.title': 'Without Assessment Criteria',
  'modal.candidateReport.jobDescription': 'Role-specific requirements, selection criteria, or areas to focus on:',
  'candidateReport.error.jobDescription.required': 'Please enter a job description',
  'modal.candidateReport.companyName': 'Name of hiring organisation:',
  'modal.candidateReport.candidateName': 'Candidate Name:',
  'modal.candidateReport.candidateName.placeholder': 'Enter full name (first and last name)',
  'modal.candidateReport.candidateFirstName': 'Candidate First Name:',
  'modal.candidateReport.candidateLastName': 'Candidate Last Name:',
  'modal.candidateReport.consultantEmail': 'Consultant Email Address:',
  'modal.candidateReport.consultantPhone': 'Consultant Phone Number:',
  'modal.candidateReport.location': 'Location:',
  'modal.candidateReport.nameExtracted': 'Candidate name extracted successfully',
  'modal.candidateReport.nameExtractionError': 'Could not extract name automatically',
  'modal.candidateReport.extractWithAI': 'Extract name using AI',
  'modal.candidateReport.aiExtract': 'Extract',
  'modal.candidateReport.positionName': 'Title of role candidate is being presented for:',
  'modal.candidateReport.consultantName': 'Consultant Name:',
  'modal.candidateReport.currentTitle': "Candidate's current or most recent title:",
  'modal.candidateReport.currentEmployer': "Candidate's current or most recent employer:",
  'modal.candidateReport.currentRemuneration': 'Current Remuneration:',
  'modal.candidateReport.desiredRemuneration': 'Desired Remuneration:',
  'modal.candidateReport.noticePeriod': 'Notice Period:',
  'modal.candidateReport.noticePeriod.placeholder': 'e.g. 4 Weeks, 2 Months, etc.',
  'modal.candidateReport.upcomingLeave': 'Upcoming Leave:',
  'modal.candidateReport.upcomingLeave.placeholder': 'e.g. 2 Weeks, 1 day, etc.',
  'modal.candidateReport.other': 'Other:',
  'modal.candidateReport.other.placeholder': 'e.g. open to working weekends, open to relocation, etc.',
  'modal.candidateReport.previous': 'Previous',
  'modal.candidateReport.next': 'Next',
  'modal.candidateReport.profilePhotoLabel': 'Candidate Photo',
  'modal.candidateReport.profilePhotoUpload': 'Upload Candidate Photo',
  'modal.candidateReport.addPhoto': 'Add Photo',
  'modal.candidateReport.changePhoto': 'Change Photo',
  'modal.candidateReport.profilePhotoError': 'Please upload a profile photo',
  'modal.candidateReport.profilePhotoSuccess': 'Candidate photo uploaded successfully',
  'modal.candidateReport.profilePhotoDelete': 'Delete Candidate Photo',
  'modal.candidateReport.profilePhotoDeleteSuccess': 'Candidate photo deleted successfully',
  'modal.candidateReport.error.failed.upload': 'Failed to upload files',
  'modal.candidateReport.error.failed.delete': 'Failed to delete file',
  'modal.candidateReport.error.noFiles': 'No files to delete',
  'modal.candidateReport.error.noFiles.upload': 'No files to upload',
  'modal.candidateReport.error.noFiles.download': 'No files to download',
  'modal.candidateReport.error.noFiles.trafficLight': 'No files to generate traffic light report',
  'modal.candidateReport.error.noFiles.delete': 'No files to delete',
  'reportItem.label.role': '{role}',
  'modal.candidateReport.submitting': 'Uploading',
  'trafficLightReport.error.unauthorised': 'Unauthorised: Please log in again',
  'trafficLightReport.error.fetch': 'Error fetching traffic light reports.\n{error}',
  'trafficLightReport.delete': 'Delete ({count})',
  'trafficLightReport.success.delete': 'Traffic Light Report deleted successfully',
  'trafficLightReport.error.delete': 'Error deleting traffic light report.\n{error}',
  'trafficLightReport.delete.confirmMessage': 'Are you sure you want to delete {count} {count, plural, one {report} other {reports}}?',
  'trafficLightReport.delete.confirmTitle': 'Delete Traffic Light Report?',

  // Cover Letter messages
  'coverLetter.empty.message': 'Please select a CV and job description document needed for cover letter generation.',
  'coverLetter.error.files': 'Please select both CV and JD files',
  'coverLetter.error.candidateName': 'Please enter candidate name',
  'coverLetter.error.upload': 'Failed to upload files',
  'coverLetter.success.upload': 'Files uploaded successfully!',
  'coverLetter.error.noFiles': 'No files to download',
  'coverLetter.buttons.delete': 'Delete ({count})',
  'coverLetter.buttons.download': 'Download ({count, plural, =0 {All} other {#}})',
  'coverLetter.buttons.upload': 'Upload',
  'coverLetter.buttons.help': 'Help',
  'coverLetter.info.title': 'Information',
  'coverLetter.info.description':
    'Please attach your resume and a position description or other relevant documentation outlining the role you are applying for. Cover letter will be generated once both documents are attached and uploaded.',
  'coverLetter.upload.title': 'Upload Files',
  'coverLetter.upload.cv': 'Upload CV',
  'coverLetter.upload.jd': 'Upload JD',
  'coverLetter.upload.submit': 'Submit',
  'coverLetter.delete.confirmTitle': 'Delete Cover Letters',
  'coverLetter.delete.confirmMessage':
    'Are you sure you want to delete {count} {count, plural, one {cover letter} other {cover letters}}?',
  'coverLetter.delete.success':
    'Successfully deleted {count} {count, plural, one {cover letter} other {cover letters}}',
  'coverLetter.upload.selectFile': 'Please select a valid file',
  'coverLetter.upload.invalidFileType': 'Please upload only PDF or DOCX files',
  'coverLetter.upload.emptyFile': 'The file appears to be empty',
  'coverLetter.upload.corruptedPdf': 'One or more file types is invalid. Please try again',
  'coverLetter.upload.corruptedDocx': 'One or more file types is invalid. Please try again',
  'coverLetter.upload.validationError': 'Unable to validate the file',

  'clientProposal.step1.rolePd.label': 'Role PD or Overview',
  'clientProposal.step1.rolePd.description':
    'Please upload the PD if you have it, or otherwise outline the specifics of the role as best you can, for summarising within the proposal',
  'clientProposal.step1.upload.fileUpload': 'File Upload',
  'clientProposal.step1.upload.addDescription': 'Add Description',
  'clientProposal.step1.upload.button': 'Upload',
  'clientProposal.step1.upload.fileTypes': 'File Type: docx, pdf',
  'clientProposal.step1.description.placeholder':
    'Manually copy or type a position description in this text field (500 char limit)',
  'clientProposal.step1.consultingTeam.label': 'Consulting Team',
  'clientProposal.step1.consultingTeam.description':
    'Please choose the consulting team for this assignment, along with their most suitable biography (if we have more than one on file). Note that the first consultant listed will be primary consultant for the role and signature page',
  'clientProposal.step1.consultingTeam.selectedCount': '{count}/4 consultants selected',
  'clientProposal.step1.consultingTeam.primaryConsultant': '(Primary Consultant)',
  'clientProposal.step1.consultingTeam.removeButton': 'Remove',
  'clientProposal.step1.consultingTeam.selectProfile': 'Select Profile',

  'newRoleCard.organisation.label': 'Organisation',
  'newRoleCard.organisation.placeholder': 'Enter organisation name',
  'newRoleCard.role.label': 'Role',
  'newRoleCard.role.placeholder': 'Enter role title',
  'newRoleCard.button.add': 'Add',
  'newRoleCard.button.cancel': 'Cancel',

  'clientProposal.step3.addColumn': 'Add Column',
  'clientProposal.step3.customColumn.addButton': 'Add Column',
  'clientProposal.step3.customColumn.cancelButton': 'Cancel',
  'clientProposal.step3.customColumn.saveButton': 'Save Changes',
  'clientProposal.step3.customColumn.nameLabel': 'Column Name',
  'clientProposal.step3.customColumn.descriptionLabel': 'Description',
  'clientProposal.step3.customColumn.addCard': 'Add Card',
  'clientProposal.step3.customColumn.cardCount': '{current}/{limit} cards',
  'clientProposal.step3.customColumn.editTitle': 'Edit Column',
  'clientProposal.step3.submit': 'Submit Proposal',
  'clientProposal.step3.submitting': 'Submitting...',
  'clientProposal.delete.confirmTitle': 'Delete Client Proposals?',
  'clientProposal.delete.confirmMessage':
    'Are you sure you want to delete {count} {count, plural, one {proposal} other {proposals}}?',

  'common.delete': 'Delete',
  'common.cancel': 'Cancel',
  'common.deleteWithCount': 'Delete ({count})',
  'common.deleteAll': 'Delete All ({count})',
  'common.delete.confirmTitle': 'Confirm Delete',
  'common.delete.confirmMessage': 'Are you sure you want to delete {count} {count, plural, one {item} other {items}}?',

  'step2.section.details': 'Details',
  'step2.section.timeline': 'Sourcing And Timeline',
  'step2.input.organisation': 'Organisation',
  'step2.input.organisation.placeholder': 'Enter organisation name',
  'step2.input.roleTitle': 'Role Title',
  'step2.input.roleTitle.placeholder': 'Enter role title',
  'step2.timeline.options': 'Timeline Date Options',
  'step2.timeline.autoFill': 'Auto Fill Timeline Dates',

  // Section Headers
  'step2.section.location': 'Location',
  'step2.section.roleInformation': 'Role Information',
  'step2.section.sourcingAndTimeline': 'Sourcing And Timeline',
  'step2.section.replacementGuarantee': 'Replacement Guarantee',

  // Details Section
  'step2.input.roleRemunerationTotal': 'Total Remuneration',
  'step2.input.roleRemunerationTotal.placeholder': 'Enter total remuneration',
  'step2.input.roleRemunerationTotal.helper': 'Must be numerical including super',
  'step2.input.clientContact': 'Client Contact',
  'step2.input.clientContact.placeholder': 'Enter client contact name',
  'step2.input.contactTitle': 'Contact Title',
  'step2.input.contactTitle.placeholder': 'Enter contact title',

  // Location Section
  'step2.input.address': 'Address',
  'step2.input.address.placeholder': 'Enter street address',
  'step2.input.suburb': 'Suburb',
  'step2.input.suburb.placeholder': 'Enter suburb',
  'step2.input.state': 'State',
  'step2.input.state.placeholder': 'Enter state',
  'step2.input.postCode': 'Post Code',
  'step2.input.postCode.placeholder': 'Enter post code',

  // Client Rate Section
  'step2.input.rate': 'Rate',
  'step2.input.rate.placeholder': 'Enter rate',

  // Understanding Needs Section
  'step2.input.roleType': 'Role Type',
  'step2.input.roleType.placeholder': 'Select a role type',

  // Client Information Section
  'step2.input.ratePercentage': 'Rate Percentage',
  'step2.input.ratePercentage.placeholder': 'Enter percentage amount',
  'step2.input.flatFee': 'Flat Fee',
  'step2.input.flatFee.placeholder': 'Enter flat fee amount',
  'step2.input.sector': 'Sector',
  'step2.input.sector.placeholder': 'Select a sector',

  // Confirmation of Assignment
  'step2.timeline.confirmationOfAssignmentDate': 'Confirmation of Assignment Date',
  'step2.timeline.confirmationOfAssignmentPeriod': 'Period',
  'step2.timeline.confirmationOfAssignmentAmount': 'Amount',
  'step2.timeline.confirmationOfAssignmentFrom': 'From',
  'step2.timeline.confirmationOfAssignmentTo': 'To',
  'step2.timeline.confirmationOfAssignmentDate.placeholder': 'Select assignment date',
  'step2.timeline.confirmationOfAssignmentPeriod.placeholder': 'Select period',
  'step2.timeline.confirmationOfAssignmentAmount.placeholder': 'Enter amount',
  'step2.timeline.confirmationOfAssignmentFrom.placeholder': 'Select start date',
  'step2.timeline.confirmationOfAssignmentTo.placeholder': 'Select end date',

  // Candidate Search
  'step2.timeline.candidateSearch': 'Candidate Search',
  'step2.timeline.candidateSearchPeriod': 'Period',
  'step2.timeline.candidateSearchAmount': 'Amount',
  'step2.timeline.candidateSearchFrom': 'From',
  'step2.timeline.candidateSearchTo': 'To',
  'step2.timeline.candidateSearchPeriod.placeholder': 'Select period',
  'step2.timeline.candidateSearchAmount.placeholder': 'Enter amount',
  'step2.timeline.candidateSearchFrom.placeholder': 'Select start date',
  'step2.timeline.candidateSearchTo.placeholder': 'Select end date',

  // Interviews
  'step2.timeline.interviewsWithShortListedCandidates': 'Interviews with Short-listed Candidates',
  'step2.timeline.interviewsPeriod': 'Period',
  'step2.timeline.interviewsAmount': 'Amount',
  'step2.timeline.interviewsFrom': 'From',
  'step2.timeline.interviewsTo': 'To',
  'step2.timeline.interviewsPeriod.placeholder': 'Select period',
  'step2.timeline.interviewsAmount.placeholder': 'Enter amount',
  'step2.timeline.interviewsFrom.placeholder': 'Select start date',
  'step2.timeline.interviewsTo.placeholder': 'Select end date',

  // Referencing
  'step2.timeline.referencingProbityAndOfferManagement': 'Referencing, Probity and Offer Management',
  'step2.timeline.referencingPeriod': 'Period',
  'step2.timeline.referencingAmount': 'Amount',
  'step2.timeline.referencingFrom': 'From',
  'step2.timeline.referencingTo': 'To',
  'step2.timeline.referencingPeriod.placeholder': 'Select period',
  'step2.timeline.referencingAmount.placeholder': 'Enter amount',
  'step2.timeline.referencingFrom.placeholder': 'Select start date',
  'step2.timeline.referencingTo.placeholder': 'Select end date',

  // Notice Period
  'step2.timeline.preferredCandidatesNoticePeriod': "Preferred Candidate's Notice Period",
  'step2.timeline.noticePeriod': 'Notice Period',
  'step2.timeline.noticePeriodFrom': 'From',
  'step2.timeline.noticePeriodTo': 'To',
  'step2.timeline.noticePeriod.placeholder': 'Select notice period',
  'step2.timeline.noticePeriodFrom.placeholder': 'Select start date',
  'step2.timeline.noticePeriodTo.placeholder': 'Select end date',

  // Start Date
  'step2.timeline.preferredStartDate': 'Preferred Engagement Start Date',
  'step2.timeline.preferredCandidatesDateToBeginWorkAtNewPosition.placeholder': 'Select preferred start date',
  'step2.timeline.preferredStartDate.placeholder': 'Select start date',

  // Replacement Guarantee
  'step2.input.replacementGuarantee': 'Replacement Guarantee',
  'step2.input.replacementGuarantee.placeholder': 'Select replacement guarantee period',

  // Validation Messages
  'step2.validation.rateError': 'You can either apply a discount or apply a flat fee, not both.',

  // Period Options (if needed)
  'step2.options.period.day': 'Day',
  'step2.options.period.week': 'Week',
  'step2.options.period.month': 'Month',

  'clientProposal.step3.editModal.title': 'Edit Role',
  'clientProposal.step3.editModal.save': 'Save Changes',
  'clientProposal.step3.editModal.cancel': 'Cancel',
  'clientProposal.empty.message': 'No current client proposals',

  'newRoleCard.input.role.label': 'Role',
  'newRoleCard.input.organisation.label': 'Organisation',
  'clientProposal.button.startWorkflow': 'Start Workflow',
  'clientProposal.button.download': 'Download ({count})',
  'step2.loading.message': 'Identifying matching roles, this may take up to a couple minutes...',

  // Traffic Light Modal
  'trafficLightModal.roleTitle.label': 'Role Title',
  'trafficLightModal.roleOverview.label': 'Role Overview',
  'trafficLightModal.roleDetails.title': 'Role Details',
  'trafficLightModal.criteriaSetup.title': 'Criteria Setup',
  'trafficLightModal.ratings.title': 'Ratings',
  'trafficLightModal.generateDescriptions.button': 'Generate Descriptions',
  'trafficLightModal.generateDescriptions.confirm': 'Are you sure?',
  'trafficLightModal.generateDescriptions.loading': 'Generating Descriptions...',
  'trafficLightModal.criteria.placeholder': 'Select criteria',
  'trafficLightModal.criteria.selectOption': 'Select criteria',
  'trafficLightModal.backToRole.button': 'Back to Role Overview',
  'trafficLightModal.backToCriteria.button': 'Back to Criteria Setup',
  'trafficLightModal.close.button': 'Close',
  'trafficLightModal.backGeneric.button': 'Back',
  'trafficLightModal.candidateOrder.title': 'Order Candidates',
  'trafficLightModal.candidateOrder.description': 'Drag and drop candidates to reorder them. This order will be used in the traffic light report.',
  'trafficLightModal.backToOrder.button': 'Back to Order',
  'trafficLightModal.next.button': 'Next',
  'trafficLightModal.previous.button': 'Previous',
  'trafficLightModal.submit.button': 'Submit',
  'trafficLightModal.submitting.button': 'Submitting...',
  'trafficLightModal.error.tooManyReports': 'Too many reports selected ({selectedCount}). Maximum allowed is {maxReports}.',

  'clientProposal.step1.uploading': 'Uploading proposal...',

  'clientProposal.metadata.team': 'Team',
  'clientProposal.metadata.lastModified': 'Last Modified',
  'clientProposal.metadata.status': 'Status',

  'clientProposal.step1.resuming.message': 'Using existing file from previous session:',

  // Step2 Error Dialog
  'step2.error.fetchRoles.title': 'Failed to Fetch Similar Roles',
  'step2.error.fetchRoles.message':
    'We were unable to fetch similar roles. Would you like to proceed without role suggestions?',
  'step2.error.fetchRoles.proceed': 'Proceed Without Roles',
  'step2.error.fetchRoles.cancel': 'Try Again',

  'step2.error.dialog.title': 'Error Processing Request',
  'step2.error.dialog.proceed': 'Proceed',
  'step2.error.dialog.tryAgain': 'Cancel',
  'step2.error.upload.message': 'Failed to save the proposal. Would you like to proceed without similar roles?',

  'common.metadata.processedDate': 'Processed: {date}',
  'common.metadata.progress': 'Progress: {progress}',

  'clientProposal.step3.findMatches': 'Find Matching Roles',

  'step2.saving.message': 'Saving...',

  'clientProposal.step3.findingMatches': 'Finding matching roles, this may take a moment...',

  'clientProposal.step3.error.findingMatches':
    'Unable to find matching roles. Please ensure all required information is provided in Step 2.',
  'clientProposal.step3.error.serverError': 'An error occurred while processing your request. Please try again later.',

  // Other placeholders
  'step2.input.roleType.other.placeholder': 'Enter role type',
  'step2.input.sector.other.placeholder': 'Enter sector',
  'step2.input.replacementGuarantee.other.placeholder': 'Enter guarantee period',

  // Navigation
  'layout.navigation.admin': 'Admin',
  'layout.navigation.promptAdjuster': 'Prompt Adjuster',

  // Prompt Adjuster
  'promptAdjuster.title': 'Prompt Adjuster',
  'promptAdjuster.description': 'This page will allow you to adjust and customize prompts used throughout the application.',
  'promptAdjuster.dropdown.label': 'Prompt',
  'promptAdjuster.dropdown.placeholder': 'Select prompt',
  'promptAdjuster.requiredVariables': 'Required Variables',
  'promptAdjuster.editor.label': 'Prompt Editor',
  'promptAdjuster.editor.placeholder': 'Enter your prompt text here. Use variables in curly braces like {variableName}.',
  'promptAdjuster.button.save': 'Save Changes',
  'promptAdjuster.save.saving': 'Saving...',
  'promptAdjuster.validation.title': 'Validation Errors',
  'promptAdjuster.validation.missingVariables': 'File "{fileName}" is missing required variables: {variables}',
  'promptAdjuster.validation.missingCount': '{count} missing',
  'promptAdjuster.loading.collections': 'Loading collections...',
  'promptAdjuster.loading.collection': 'Loading prompt collection...',
  'promptAdjuster.loading.saving': 'Saving...',
  'promptAdjuster.toast.success': 'Prompt collection saved successfully',
  'promptAdjuster.override.indicator': 'OVERRIDE',
  'promptAdjuster.override.metadata': 'Modified by {user} on {date}',
  
  // Teams transcript processing messages
  'promptAdjuster.transcript.uploadTitle': 'Upload Transcript',
  'promptAdjuster.transcript.previewTitle': 'Transcript Preview',
  'promptAdjuster.transcript.selectFile': 'Select VTT File',
  'promptAdjuster.transcript.clear': 'Clear',
  'promptAdjuster.transcript.run': 'Process Transcript',
  'promptAdjuster.transcript.fileSelected': 'File: {fileName} ({size} KB)',
  'promptAdjuster.transcript.noPreview': 'No transcript file selected. Upload a VTT file to see preview.',
  'promptAdjuster.transcript.loadingPreview': 'Loading preview...',
  'promptAdjuster.transcript.invalidFileType': 'Please select a valid VTT file',
  'promptAdjuster.transcript.readError': 'Error reading transcript file',
  'promptAdjuster.transcript.noFile': 'Please select a transcript file first',
  'promptAdjuster.transcript.processing': 'Processing transcript...',
  'promptAdjuster.transcript.success': 'Transcript processed successfully',
  'promptAdjuster.transcript.error': 'Error processing transcript',
  'promptAdjuster.transcript.saveError': 'Error saving prompt changes',
  'promptAdjuster.transcript.saveDisclaimer': 'Note: Process Transcript will automatically save any prompt changes before processing.',
  'promptAdjuster.transcript.processingComplete': 'Transcript processing completed successfully!',
  'promptAdjuster.transcript.downloadResults': 'Download Results (JSON)',
  'promptAdjuster.transcript.downloadWord': 'Download Word Document',
  'promptAdjuster.transcript.downloadSuccess': 'Results downloaded successfully',
  'promptAdjuster.transcript.wordDownloadSuccess': 'Word document downloaded successfully',
  'promptAdjuster.transcript.wordDownloadError': 'Error downloading Word document',
};
